/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DateString } from './dateString';

export interface AdminBasic { 
    user_id: string;
    /**
     * individual alias or organization name
     */
    displayed_name: string;
    image_url?: string;
    created_date: DateString;
    last_visit_date?: DateString;
}